import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Candidate|Exam|Details`;

export type SPCandidateExamDetailLoc =
	| 'SPCandidateExamDetailLabelNotViewedItemCount'
	| 'SPCandidateExamDetailLabelItemCount'
	| 'SPCandidateExamDetailLabelMaxRawScore'
	| 'SPCandidateExamDetailLabelRawCutScore'
	| 'SPCandidateExamDetailsLabelProctorId'
	| 'SPCandidateExamDetailLabelPoints'
	| 'SPCandidateExamDetailLabelThetaScore';

export const spCandidateExamDetailLocs: LocDefs<SPCandidateExamDetailLoc> = {
	SPCandidateExamDetailLabelNotViewedItemCount: {
		defaultValue: 'Not Viewed Item Count',
		description: 'Label for : Not viewed Item Count.',
		displayPath: `${dpRoot}|Not Viewed Item Count`,
		displayType: 'Label',
		portal: 'SP',
		feature: HubFeature.ExamMsftExamDetails,
	},
	SPCandidateExamDetailLabelItemCount: {
		defaultValue: 'Item Count',
		description: 'Label for : Item Count.',
		displayPath: `${dpRoot}|Item Count`,
		displayType: 'Label',
		portal: 'SP',
		feature: HubFeature.ExamMsftExamDetails,
	},
	SPCandidateExamDetailLabelMaxRawScore: {
		defaultValue: 'Max Raw Score',
		description: 'Label for : Max Raw Score.',
		displayPath: `${dpRoot}|Max Raw Score`,
		displayType: 'Label',
		portal: 'SP',
		feature: HubFeature.ExamMsftExamDetails,
	},
	SPCandidateExamDetailLabelRawCutScore: {
		defaultValue: 'Raw Cut Score',
		description: 'Label for : Raw Cut Score.',
		displayPath: `${dpRoot}|Raw Cut Score`,
		displayType: 'Label',
		portal: 'SP',
		feature: HubFeature.ExamMsftExamDetails,
	},
	SPCandidateExamDetailsLabelProctorId: {
		defaultValue: 'Proctor ID',
		description: 'Label for the Proctor ID field',
		displayPath: 'Proctor ID',
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'SP',
	},
	SPCandidateExamDetailLabelPoints: {
		defaultValue: 'Points',
		description: 'Label for : Points.',
		displayPath: `${dpRoot}|Points`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCiscoCustomDisplayExamCatalogPoints,
		portal: 'SP',
	},
	SPCandidateExamDetailLabelThetaScore: {
		defaultValue: 'Theta Score',
		description: 'Label for: Theta Score.',
		displayPath: `${dpRoot}|Theta Score`,
		displayType: 'Label',
		feature: HubFeature.ThetaScoreDisplayInUi,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<SPCandidateExamDetailLoc>(spCandidateExamDetailLocs);
